export const setCategoryAction = (payload) => {
    return {
        type: "category",
        payload
    }
};

export const setMealsAction = (payload) => {
    return {
        type: "meals",
        payload
    }
};

export const setAlternativeCategoriesAction = (payload) => {
    return {
        type: "alternative_categories",
        payload
    }
};

export const setLocationAction = (payload) => {
    return {
        type: "location",
        payload
    }
};

export const setAccommodationTypeAction = (payload) => {
    return {
        type: "accommodationType",
        payload
    }
};

export const setFoodAction = (payload) => {
    return {
        type: "food",
        payload
    }
};

export const setEatingHabitAction = (payload) => {
    return {
        type: "eatingHabit",
        payload
    }
};

export const setArrivalAction = (payload) => {
    return {
        type: "arrival",
        payload
    }
};

export const setDepartureAction = (payload) => {
    return {
        type: "departure",
        payload
    }
};

export const setAdultAction = (payload) => {
    return {
        type: "adult",
        payload
    }
};

export const setChildAction = (payload) => {
    return {
        type: "child",
        payload
    }
};

export const setChildAgeAction = (payload) => {
    return {
        type: "childAge",
        payload
    }
};

export const resetAction = (payload) => {
    return {
        type: "reset",
        payload
    }
};
